import { RestService } from "./RestService";

export class CompanyRestService extends RestService {
  constructor() {
    super("/api/v1/companies");
  }
}
